const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;

const Image1 = imageBaseUrl + "popular1.png";
const Image2 = imageBaseUrl + "popular2.png";
const Image3 = imageBaseUrl + "popular3.png";
const Image4 = imageBaseUrl + "popular4.png";

const USAPopular = [
  {
    id: 1,
    Image: Image1,
    title: "Computer Science and Engineering",
    items: ["Computer Science", "Software Engineering", "Data Science"],
  },
  {
    id: 2,
    Image: Image2,
    title: "Business Administration and Management",
    items: ["MBA", "Business Analytics"],
  },
  {
    id: 3,
    Image: Image3,
    title: "Health Sciences and Medicine",
    items: [
      "Psychology",
      "Medicine",
      "Nursing",
      "Public Health",
      "Healthcare Management",
    ],
  },
  {
    id: 4,
    Image: Image4,
    title: "Economics and Finance",
    items: ["Economics", "Finance", "Accounting", "Business Economics"],
  },
  {
    id: 5,
    Image: Image1,
    title: "STEM",
    items: ["Biology", "Chemistry", "Physics", "Mathematics", "Engineering"],
  },
  {
    id: 6,
    Image: Image2,
    title: "Law",
    items: ["JD", "LLM ", "Legal Studies"],
  },
  {
    id: 7,
    Image: Image3,
    title: "Creative Arts and Design",
    items: ["Fine Arts", "Graphic Design", "Architecture", "Film Studies"],
  },
];
const UKPopular = [
  {
    id: 1,
    Image: Image1,
    title: "Computer Science and Engineering",
    items: ["Computer Science", "Software Engineering", "Data Science"],
  },
  {
    id: 2,
    Image: Image2,
    title: "Business Administration and Management",
    items: ["MBA", "Business Analytics"],
  },
  {
    id: 3,
    Image: Image3,
    title: "Health Sciences and Medicine",
    items: [
      "Psychology",
      "Medicine",
      "Nursing",
      "Public Health",
      "Healthcare Management",
    ],
  },
  {
    id: 4,
    Image: Image4,
    title: "Economics and Finance",
    items: ["Economics", "Finance", "Accounting", "Business Economics"],
  },
  {
    id: 5,
    Image: Image1,
    title: "STEM",
    items: ["Biology", "Chemistry", "Physics", "Mathematics", "Engineering"],
  },
  {
    id: 6,
    Image: Image2,
    title: "Law",
    items: ["JD", "LLM ", "Legal Studies"],
  },
  {
    id: 7,
    Image: Image3,
    title: "Creative Arts and Design",
    items: ["Fine Arts", "Graphic Design", "Architecture", "Film Studies"],
  },
  {
    id: 8,
    Image: Image4,
    title: "Literature",
    items: ["English Literature"],
  },
];
const IrelandPopular = [
  {
    id: 1,
    Image: Image1,
    title: "Computer Science and Engineering",
    items: ["Computer Science", "Software Engineering", "Data Science"],
  },
  {
    id: 2,
    Image: Image2,
    title: "Business Administration and Management",
    items: ["MBA", "Business Analytics"],
  },
  {
    id: 3,
    Image: Image3,
    title: "Health Sciences and Medicine",
    items: ["Biotechnology", "Medicine", "Pharmaceuticals"],
  },
  {
    id: 4,
    Image: Image4,
    title: "Economics and Finance",
    items: ["Economics", "International Relations"],
  },
  {
    id: 5,
    Image: Image1,
    title: "STEM",
    items: ["Biology", "Chemistry", "Physics", "Mathematics", "Engineering"],
  },
];
const CanadaPopular = [
  {
    id: 1,
    Image: Image1,
    title: "Computer Science and Engineering",
    items: ["Computer Science", "Software Engineering", "Data Science"],
  },
  {
    id: 2,
    Image: Image2,
    title: "Business Administration and Management",
    items: ["MBA", "Business Analytics"],
  },
  {
    id: 3,
    Image: Image3,
    title: "Health Sciences and Medicine",
    items: [
      "Psychology",
      "Medicine",
      "Nursing",
      "Public Health",
      "Healthcare Management",
    ],
  },
  {
    id: 4,
    Image: Image4,
    title: "Economics and Finance",
    items: ["Economics", "Finance", "Accounting", "Business Economics"],
  },
  {
    id: 5,
    Image: Image1,
    title: "STEM",
    items: ["Biology", "Chemistry", "Physics", "Mathematics", "Engineering"],
  },
];
const GermanyPopular = [
  {
    id: 1,
    Image: Image1,
    title: "Computer Science and Engineering",
    items: ["Computer Science", "Software Engineering", "Data Science"],
  },
  {
    id: 2,
    Image: Image2,
    title: "Business Administration and Management",
    items: [
      "MBA",
      "Business Analytics",
      "Marketing",
      "Human Resource Management",
    ],
  },
  {
    id: 3,
    Image: Image3,
    title: "Health Sciences and Medicine",
    items: [
      "Psychology",
      "Medicine",
      "Nursing",
      "Public Health",
      "Healthcare Management",
      "Dentistry",
      "Pharmacy",
      "Physical Therapy",
    ],
  },
  {
    id: 4,
    Image: Image4,
    title: "Economics and Finance",
    items: [
      "Economics",
      "Finance",
      "Accounting",
      "Business Economics",
      "Financial Mathematics",
      "Actuarial Science",
    ],
  },
  {
    id: 5,
    Image: Image1,
    title: "STEM",
    items: [
      "Biology",
      "Chemistry",
      "Physics",
      "Mathematics",
      "Engineering",
      "Astrophysics",
      "Civil Engineering",
    ],
  },
];
const AustraliaPopular = [
  {
    id: 1,
    Image: Image1,
    title: "Computer Science and Engineering",
    items: ["Computer Science", "Software Engineering", "Data Science"],
  },
  {
    id: 2,
    Image: Image2,
    title: "Business Administration and Management",
    items: [
      "MBA",
      "Business Analytics",
      "Marketing",
      "Human Resource Management",
    ],
  },
  {
    id: 3,
    Image: Image3,
    title: "Health Sciences and Medicine",
    items: [
      "Psychology",
      "Medicine",
      "Nursing",
      "Public Health",
      "Healthcare Management",
      "Dentistry",
      "Pharmacy",
      "Physical Therapy",
    ],
  },
  {
    id: 4,
    Image: Image4,
    title: "Economics and Finance",
    items: [
      "Economics",
      "Finance",
      "Accounting",
      "Business Economics",
      "Investment Banking",
      "Risk Management",
    ],
  },
  {
    id: 5,
    Image: Image1,
    title: "STEM",
    items: [
      "Biology",
      "Chemistry",
      "Physics",
      "Mathematics",
      "Engineering",
      "Astrophysics",
      "Civil Engineering",
    ],
  },
];
const SingaporePopular = [
  {
    id: 1,
    Image: Image1,
    title: "Computer Science and Engineering",
    items: ["Computer Science", "Software Engineering", "Data Science"],
  },
  {
    id: 2,
    Image: Image2,
    title: "Business Administration and Management",
    items: [
      "MBA",
      "Business Analytics",
      "Marketing",
      "Human Resource Management",
    ],
  },
  {
    id: 3,
    Image: Image3,
    title: "Health Sciences and Medicine",
    items: [
      "Psychology",
      "Medicine",
      "Nursing",
      "Public Health",
      "Healthcare Management",
      "Dentistry",
      "Pharmacy",
      "Physical Therapy",
    ],
  },
  {
    id: 4,
    Image: Image4,
    title: "Economics and Finance",
    items: [
      "Economics",
      "Finance",
      "Accounting",
      "Business Economics",
      "Investment Banking",
      "Risk Management",
    ],
  },
  {
    id: 5,
    Image: Image1,
    title: "STEM",
    items: [
      "Biology",
      "Chemistry",
      "Physics",
      "Mathematics",
      "Engineering",
      "Astrophysics",
      "Civil Engineering",
    ],
  },
];
const ItalyPopular = [
  {
    id: 1,
    Image: Image1,
    title: "Computer Science and Engineering",
    items: ["Computer Science", "Software Engineering", "Data Science"],
  },
  {
    id: 2,
    Image: Image2,
    title: "Business Administration and Management",
    items: [
      "MBA",
      "Business Analytics",
      "Marketing",
      "Human Resource Management",
    ],
  },
  {
    id: 3,
    Image: Image3,
    title: "Health Sciences and Medicine",
    items: [
      "Psychology",
      "Medicine",
      "Nursing",
      "Public Health",
      "Healthcare Management",
      "Dentistry",
      "Pharmacy",
      "Physical Therapy",
    ],
  },
  {
    id: 4,
    Image: Image4,
    title: "Economics and Finance",
    items: [
      "Economics",
      "Finance",
      "Accounting",
      "Business Economics",
      "Investment Banking",
      "Risk Management",
    ],
  },
  {
    id: 5,
    Image: Image1,
    title: "STEM",
    items: [
      "Biology",
      "Chemistry",
      "Physics",
      "Mathematics",
      "Engineering",
      "Astrophysics",
      "Civil Engineering",
    ],
  },
];
const FrancePopular = [
  {
    id: 1,
    Image: Image1,
    title: "Computer Science and Engineering",
    items: [
      "Computer Science",
      "Software Engineering",
      "Information Technology",
    ],
  },
  {
    id: 2,
    Image: Image2,
    title: "Business Administration and Management",
    items: ["MBA", "Business Analytics", "Management"],
  },
  {
    id: 3,
    Image: Image3,
    title: "Health Sciences and Medicine",
    items: ["Medicine", "Nursing", "Public Health"],
  },
  {
    id: 4,
    Image: Image4,
    title: "Economics and Finance",
    items: ["Economics", "Finance", "International Business"],
  },
  {
    id: 5,
    Image: Image1,
    title: "STEM",
    items: ["Chemistry", "Physics", "Mathematics", "Engineering"],
  },
  {
    id: 6,
    Image: Image2,
    title: "Law",
    items: ["Law", "International Law ", "Legal Studies"],
  },
  {
    id: 7,
    Image: Image3,
    title: "Creative Arts and Design",
    items: ["Fine Arts", "Graphic Design", "Design", "Fashion Design"],
  },
  {
    id: 8,
    Image: Image4,
    title: "Literature",
    items: ["Literature", "French Studies", "Comparative Literature"],
  },
];
const DubaiPopular = [
  {
    id: 1,
    Image: Image1,
    title: "Computer Science and Engineering",
    items: ["Computer Science", "Software Engineering", "Data Science"],
  },
  {
    id: 2,
    Image: Image2,
    title: "Business Administration and Management",
    items: [
      "MBA",
      "Business Analytics",
      "Marketing",
      "Human Resource Management",
    ],
  },
  {
    id: 3,
    Image: Image3,
    title: "Health Sciences and Medicine",
    items: [
      "Psychology",
      "Medicine",
      "Nursing",
      "Public Health",
      "Healthcare Management",
      "Dentistry",
      "Pharmacy",
      "Physical Therapy",
    ],
  },
  {
    id: 4,
    Image: Image4,
    title: "Economics and Finance",
    items: [
      "Economics",
      "Finance",
      "Accounting",
      "Business Economics",
      "Investment Banking",
      "Risk Management",
    ],
  },
  {
    id: 5,
    Image: Image1,
    title: "STEM",
    items: [
      "Biology",
      "Chemistry",
      "Physics",
      "Mathematics",
      "Engineering",
      "Engineering",
      "Astrophysics",
      "Civil Engineering",
    ],
  },
];

const NewZealandPopular = [
  {
    id: 1,
    Image: Image1,
    title: "Computer Science and Engineering",
    items: ["Computer Science", "Software Engineering", "Data Science"],
  },
  {
    id: 2,
    Image: Image2,
    title: "Business Administration and Management",
    items: [
      "MBA",
      "Business Analytics",
      "Marketing",
      "Human Resource Management",
    ],
  },
  {
    id: 3,
    Image: Image3,
    title: "Health Sciences and Medicine",
    items: [
      "Psychology",
      "Medicine",
      "Nursing",
      "Public Health",
      "Healthcare Management",
      "Dentistry",
      "Pharmacy",
      "Physical Therapy",
    ],
  },
  {
    id: 4,
    Image: Image4,
    title: "Economics and Finance",
    items: [
      "Economics",
      "Finance",
      "Accounting",
      "Business Economics",
      "Investment Banking",
      "Risk Management",
    ],
  },
  {
    id: 5,
    Image: Image1,
    title: "STEM",
    items: [
      "Biology",
      "Chemistry",
      "Physics",
      "Mathematics",
      "Engineering",
      "Engineering",
      "Astrophysics",
      "Civil Engineering",
    ],
  },
];

const IndiaPopular = [
  {
    id: 1,
    Image: Image1,
    title: "ENGINEERING",
  },
  {
    id: 2,
    Image: Image2,
    title: "MEDICAL & PARA MEDICAL",
  },
  {
    id: 3,
    Image: Image3,
    title: "AGRICULTURE & ALLIED SCIENCEL",
  },
  {
    id: 4,
    Image: Image4,
    title: "MANAGEMENT",
  },
  {
    id: 5,
    Image: Image1,
    title: "TOURISM & HOTEL INDUSTRY",
  },
  {
    id: 6,
    Image: Image1,
    title: "SCIENCES",
  },
  {
    id: 7,
    Image: Image3,
    title: "HUMANITIES & LIBERAL ARTS ",
  },
  {
    id: 8,
    Image: Image4,
    title: "HEALTH SCIENCES",
  },
  {
    id: 9,
    Image: Image1,
    title: "LAW",

  }
];
export {
  USAPopular,
  UKPopular,
  IrelandPopular,
  CanadaPopular,
  GermanyPopular,
  AustraliaPopular,
  SingaporePopular,
  ItalyPopular,
  FrancePopular,
  DubaiPopular,
  NewZealandPopular,
  IndiaPopular,
};
